import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IActTeamMemberActions, IThunkGetAvailableActTeamMembers } from '../types';

const onGetAvailableActTeamMembers: IThunkGetAvailableActTeamMembers = thunk(
  async ({ setAvailableActTeamMembers }: Actions<IActTeamMemberActions>, payload) => {
    const { clinicId, actTeamId } = payload;

    const { data } = await api.actTeamMember.getActTeamMemberList(clinicId, actTeamId);

    setAvailableActTeamMembers(data);
  },
);

export default onGetAvailableActTeamMembers;
